import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Clone from 'lodash/clone';
import FiltersContentLoader from '../../../../components/FiltersContentLoader';
import LoadMask from '../../../../components/LoadMask';
import PagePagination from '../../../../components/PagePagination';
import ENDPOINT from '../../../../constants/endpoints';
import {useGrid} from '../../../../hooks/useGrid';
import FirmEmployeesItem from './components/FirmEmployeesItem';
import './styles.css';

const FirmEmployees = props => {
  const { firmId, candidateId, actions } = props;
  const {
    data: {
      isFetching: gridIsFetching,
      rows,
      rowsCount,
      pagesCount,
      page,
      perPage,
    },
    actions: gridActions,
  } = useGrid(ENDPOINT.COLLECTION.FIRM_EMPLOYEE, null, false);

  const [isFetching, setFetching] = useState();

  useEffect(() => {
    if (firmId) {
      gridActions.fetch({ id: firmId });
    }
  }, [firmId]);

  useEffect(() => {
    if ((!isFetching && gridIsFetching) || (isFetching && !gridIsFetching)) {
      setFetching(gridIsFetching);
    }
  }, [gridIsFetching]);

  const changeStatus = (person, status, data = {}) => {
    const updatedRows = Clone(rows);
    updatedRows.forEach((row, index) => {
      if (row === person) {
        updatedRows[index].Status = status;

        if (data && typeof data === 'object') {
          updatedRows[index] = { ...updatedRows[index], ...data };
        }
      }
    });

    return updatedRows;
  };

  const onClickAcceptHandler = (person, status) => {
    setFetching(true);
    actions
      .accept({ token: person.Token })
      .then(response =>
        gridActions.setDataRows(changeStatus(person, status, response || {}))
      )
      .finally(() => setFetching(false));
  };

  const onClickRejectHandler = (person, status) => {
    setFetching(true);
    actions
      .reject({ token: person.Token })
      .then(response =>
        gridActions.setDataRows(changeStatus(person, status, response || {}))
      )
      .finally(() => setFetching(false));
  };

  const onClickConnectHandler = (person, status) => {
    setFetching(true);
    actions
      .connect({ id: person.CandidateID })
      .then(() => gridActions.setDataRows(changeStatus(person, status)))
      .finally(() => setFetching(false));
  };

  const onClickMessageHandler = person => {
    actions.message(person.CandidateID, person.FullName);
  };

  const records = useMemo(
    () =>
      rows.map(person => (
        <FirmEmployeesItem
          key={person.CandidateID}
          person={person}
          candidateId={candidateId}
          actions={{
            onClickAcceptHandler,
            onClickRejectHandler,
            onClickConnectHandler,
            onClickMessageHandler,
          }}
        />
      )),
    [rows]
  );

  return !isFetching ? (
    !!rows.length ? (
      <div className="sidebar__widget">
        {isFetching && <LoadMask relative />}
        <h3 className="sidebar__title">Firm Employees</h3>
        <div className="firm-employees__list">{records}</div>
        {Number(pagesCount) > 1 && (
          <div className="sidebar__pagination">
            <PagePagination
              page={page}
              perPage={perPage}
              count={rowsCount}
              pageRangeDisplayed={4}
              controlFunc={gridActions.readPage}
              hideFirstLastPages={false}
              hideNavigation={true}
              minimalStyle={true}
              scrollToTop={false}
            />
          </div>
        )}
      </div>
    ) : null
  ) : (
    <FiltersContentLoader />
  );
};

FirmEmployees.propTypes = {
  firmId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  candidateId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  actions: PropTypes.shape({
    connect: PropTypes.func.isRequired,
    accept: PropTypes.func.isRequired,
    reject: PropTypes.func.isRequired,
  }).isRequired,
};

export default FirmEmployees;
